import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {hotModuleReplacement} from './hot-store';
import { ProdModule } from './prod.module';

export function bootstrapProdModule() {
  enableProdMode();
  hotModuleReplacement(() => platformBrowserDynamic().bootstrapModule(ProdModule), module);
}





// WEBPACK FOOTER //
// ./src/setup/prod.bootstrap.ts